import ConsultSection from "../PageElements/HomePageElements/ConsultSection";
import TermsAndConditionMainSection from "../PageElements/TermsAndConditionsPageElement/TermsAndConditionMainSection";


export default function TermsAndCondition() {
    return (
        <>

            <TermsAndConditionMainSection/>
            <ConsultSection/>
            
        </>
    )
}